import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import MaterialDialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';

import indigo from '@material-ui/core/colors/indigo';

import { ConfirmDialog } from 'components/admin/Dialogs';
import {
  helpDispatch,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

const styles = theme => ({
  rootContent: {
    backgroundColor: indigo[50],
  },
  title: {
    backgroundColor: indigo[500],
  },
  titleText: {
    margin: theme.spacing.unit,
    color: "#fff"
  },
  dialogActions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
});

class Dialog extends Component {
  constructor(props) {
    super(props);
    this.state = { showDelete: false };
  }

  handleCancel = () => {
    this.setState({ showDelete: false });
  }

  handleDelete = () => {
    const { onClose, onDelete } = this.props;

    if (onDelete) {
      onDelete()
        .then(() => onClose());
    } else {
      onClose();
    }
  }

  render() {
    const {
      classes,
      children,
      confirmDelete,
      deleteTitle,
      deleteText,
      handleCreated,
      show,
      title,
      type,
      onClose,
      onDelete,
      onDone,
      validate,
      hideTitle,
      hideActions
    } = this.props;
    const { showDelete } = this.state;

    return (
      <div>
        <ConfirmDialog
          open={showDelete}
          title={deleteTitle}
          contentText={deleteText}
          handleCancel={this.handleCancel}
          handleOk={this.handleDelete}
        />
        <MaterialDialog
          maxWidth="md"
          open={show}
          onClose={onClose}
        >
          {!hideTitle &&
            <DialogTitle className={classes.title}>
              <div>
                <Typography variant="display1" className={classes.titleText}>
                  {title}
                </Typography>
              </div>
            </DialogTitle>
          }
          <DialogContent classes={{root: classes.rootContent}}>
            {children}
          </DialogContent>
          {!hideActions &&
            <DialogActions className={classes.dialogActions}>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Tooltip type={TooltipTypes.setup.ACTIONS} placement="left">
                  <div />
                </Tooltip>
                {type !== "add" &&
                  <Button
                    onClick={() => {
                      if (confirmDelete) {
                        this.setState({ showDelete: true });
                      } else if (onDelete) {
                        onDelete()
                          .then(() => onClose());
                      } else {
                        onClose();
                      }
                    }}
                  >
                    Delete
                  </Button>
                }
              </div>

              <div>
                <Button onClick={onClose} color="primary">
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    if (onDone) {
                      if(validate) {
                        if (validate()) {
                          onDone()
                            .then((result) => {
                              if (handleCreated) {
                                handleCreated(result.key);
                              }
                              onClose()
                            });
                        }
                      } else {
                        onDone()
                          .then(() => onClose());
                      }

                    } else {
                      onClose();
                    }
                  }}
                  color="primary">
                  {type === "add" ? "Add" : "Done"}
                </Button>
              </div>
            </DialogActions>
          }
        </MaterialDialog>
      </div>
    );
  }
}
// const Dialog = (props) => {
//   const {
//     classes,
//     children,
//     confirmDelete,
//     show,
//     title,
//     type,
//     onClose,
//     onDelete,
//     onDone,
//     validate,
//     hideTitle,
//     hideActions
//   } = props;
//
//   return (
//     <div>
//       <MaterialDialog
//         maxWidth="md"
//         open={show}
//         onClose={onClose}
//       >
//         {!hideTitle &&
//           <DialogTitle className={classes.title}>
//             <div>
//               <Typography variant="display1" className={classes.titleText}>
//                 {title}
//               </Typography>
//             </div>
//           </DialogTitle>
//         }
//         <DialogContent classes={{root: classes.rootContent}}>
//           {children}
//         </DialogContent>
//         {!hideActions &&
//           <DialogActions className={classes.dialogActions}>
//             <Button
//               onClick={() => {
//                 if (onDelete) {
//                   onDelete()
//                     .then(() => onClose());
//                 } else {
//                   onClose();
//                 }
//               }}
//             >
//               Delete
//             </Button>
//             <div>
//               <Button onClick={onClose} color="primary">
//                 Cancel
//               </Button>
//               <Button
//                 onClick={() => {
//                   if (onDone) {
//                     if(validate) {
//                       if (validate()) {
//                         onDone()
//                           .then(() => onClose());
//                       }
//                     } else {
//                       onDone()
//                         .then(() => onClose());
//                     }
//
//                   } else {
//                     onClose();
//                   }
//                 }}
//                 color="primary">
//                 {type === "add" ? "Add" : "Done"}
//               </Button>
//             </div>
//           </DialogActions>
//         }
//       </MaterialDialog>
//     </div>
//   );
// }

export default withStyles(styles)(Dialog);



// WEBPACK FOOTER //
// ./src/components/core/Dialog.jsx